export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-06.b1dfe6f1.jpg";